import tns from 'tiny-slider'

const container = document.querySelector('.js-hero')
if (container) {
  tns({
    container,
    mode: 'gallery',
    nav: false,
    controlsPosition: 'bottom',
    speed: 2000
  })
}
